<figure class="container-address">
  <section>
    <img
      [src]="replaceBucket.replaceBucket(dataSignal()?.cover_image_url)"
      [alt]="dataSignal()?.name"
      [title]="dataSignal()?.name"
      class="item-image"
      loading="lazy"
    />
    <div class="container-social-media">
      @for (item of socialMediaSignal(); track i; let i = $index) {
      <div
        class="item-social-media cursor-pointer"
        (click)="onClickSocialMedia(item)"
        (keyup.enter)="onClickSocialMedia(item)"
        tabindex="0"
      >
        <img [src]="item.icon" alt="ไอคอนสำหรับลิงค์ไปยูทูป" title="ไอคอนสำหรับลิงค์ไปยูทูป" loading="lazy" />
      </div>
      }
    </div>
  </section>
  <figcaption>
    <h2 class="font-size-40 font-weight-bold title-address cursor-default">{{ dataSignal()?.name }}</h2>
    <div class="container-location">
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">home</mat-icon>
        </div>
        <p class="cursor-default font-size-16">{{ dataSignal().address }}</p>
      </div>
      <!-- Time -->
      @if(dataSignal()?.working_days && (dataSignal()?.working_days.monday.enable || dataSignal()?.working_days.tuesday.enable ||
      dataSignal()?.working_days.wednesday.enable || dataSignal()?.working_days.thursday.enable || dataSignal()?.working_days.friday.enable
      || dataSignal()?.working_days.saturday.enable || dataSignal()?.working_days.sunday.enable)){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">schedule</mat-icon>
        </div>
        <div>
          <p class="font-size-16 font-weight-bold cursor-default">เวลาทำการ</p>
          <dl class="item-time cursor-default">
            <div class="flex flex-wrap">
              <dt class="font-size-16">วันจันทร์</dt>
              @if(dataSignal()?.working_days.monday.enable) {
              <dd class="font-size-16">{{ dataSignal()?.working_days.monday.open }}-{{ dataSignal()?.working_days.monday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันอังคาร</dt>
              @if(dataSignal()?.working_days.tuesday.enable) {
              <dd class="font-size-16">{{ dataSignal()?.working_days.tuesday.open }}-{{ dataSignal()?.working_days.tuesday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันพุธ</dt>
              @if(dataSignal()?.working_days.wednesday.enable) {
              <dd class="font-size-16">{{ dataSignal()?.working_days.wednesday.open }}-{{ dataSignal()?.working_days.wednesday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันพฤหัสบดี</dt>
              @if(dataSignal()?.working_days.thursday.enable) {
              <dd class="font-size-16">{{ dataSignal()?.working_days.thursday.open }}-{{ dataSignal()?.working_days.thursday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันศุกร์</dt>
              @if(dataSignal()?.working_days.friday.enable) {
              <dd class="font-size-16">{{ dataSignal()?.working_days.friday.open }}-{{ dataSignal()?.working_days.friday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันเสาร์</dt>
              @if(dataSignal()?.working_days.saturday.enable){

              <dd class="font-size-16">{{ dataSignal()?.working_days.saturday.open }}-{{ dataSignal()?.working_days.saturday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>

            <div class="flex flex-wrap">
              <dt class="font-size-16">วันอาทิตย์</dt>
              @if(dataSignal()?.working_days.sunday.enable){
              <dd class="font-size-16">{{ dataSignal()?.working_days.sunday.open }}-{{ dataSignal()?.working_days.sunday.close }}</dd>
              } @else {
              <dd class="font-18">ปิดทำการ</dd>
              }
            </div>
          </dl>
        </div>
      </div>
      }

      <!-- ---- -->
      @if(dataSignal().tel){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">phone</mat-icon>
        </div>
        <a href="tel:{{ dataSignal().tel }}" class="font-size-16">{{ dataSignal().tel }}</a>
      </div>
      } @if(dataSignal().email){
      <div class="item-address">
        <div class="icon-address">
          <mat-icon class="icon-green">mail</mat-icon>
        </div>
        <a href="mailto:{{ dataSignal().email }}" class="font-size-16">{{ dataSignal().email }}</a>
      </div>
      } @if(parseLocation(dataSignal().location_lat) !== 0 && parseLocation(dataSignal().location_lng) !== 0){
      <a
        class="item-location font-size-16"
        (click)="onClickLocationBranch(dataSignal().location_lat, dataSignal().location_lng)"
        tabindex="0"
        (keydown)="onClickLocationBranch(dataSignal().location_lat, dataSignal().location_lng)"
      >
        เส้นทางการเดินทาง
      </a>
      }
    </div>
  </figcaption>
</figure>
